import { useEffect } from "react";
import { useAuth } from "@/App";
import { getGeoPermissionState, requestGeoPermission } from "@/utils/geo";

/** Chiede il permesso posizione del sistema, senza alcun messaggio nell'app. */
export default function GeoPermissionBanner() {
  const { user } = useAuth();

  useEffect(() => {
    if (!user?.geo_tracking) return;
    let cancelled = false;
    (async () => {
      const state = await getGeoPermissionState();
      if (cancelled || state !== "prompt") return;
      requestGeoPermission();
    })();
    return () => { cancelled = true; };
  }, [user]);

  return null;
}
